import React, { Fragment, memo } from 'react'
import styles from './PreviewSectionItem.module.scss'

type Props = {
    items: Item[]
}

type Item = {
    label: string
    data: string[]
}

const PreviewSectionItem: React.FC<Props> = memo((props: Props) => {
    function checkIfShowDivider(index: number, length: number) {
        return (index === 0 || index !== length - 1) && length !== 1
    }

    return (
        <table className={styles.table}>
            <tbody>
                {
                    props.items.map((item, firstIndex) => {
                        return (
                            <tr key={firstIndex}>
                                <td className={styles.label}>{item.label}</td>
                                <td className={item.data.length > 1 ? styles.data : ''}>
                                    {
                                        item.data.length === 0 ? 'N/A' : item.data.map((data, index) => {
                                            return (
                                                <Fragment key={index}>
                                                    <div className={`${styles.dataItem}`}>{data}</div>
                                                    {
                                                        checkIfShowDivider(index, item.data.length) && <div className={styles.divider}>|</div>
                                                    }
                                                </Fragment>
                                            )
                                        })
                                    }
                                </td>
                            </tr>
                        )
                    })
                }
            </tbody>
        </table>
    )
})

export default PreviewSectionItem